module.exports = __webpack_public_path__ + "static/img/44.28995ae.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/qq/44.gif
// module id = C2eR
// module chunks = 0